/**
 * @generated SignedSource<<c64b2d16ec04d359aef938e61715f9fc>>
 * @relayHash 980c9aa7758987e0653c5d321799edb9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d93bbf1c1a7473bb11e620e4e166ea1b3c13685bef67a869a5c2868e8f2ae423

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GuildDonationScreenContentUpdateAmountMutation$variables = {
  amount: number;
  guildId: string;
  paymentIntentId: string;
};
export type GuildDonationScreenContentUpdateAmountMutation$data = {
  readonly updatePaymentIntentAmount: {
    readonly clientSecret: string | null | undefined;
    readonly feesPayer: string | null | undefined;
    readonly paymentIntentId: string | null | undefined;
  };
};
export type GuildDonationScreenContentUpdateAmountMutation = {
  response: GuildDonationScreenContentUpdateAmountMutation$data;
  variables: GuildDonationScreenContentUpdateAmountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guildId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paymentIntentId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      },
      {
        "kind": "Variable",
        "name": "guildId",
        "variableName": "guildId"
      },
      {
        "kind": "Variable",
        "name": "paymentIntentId",
        "variableName": "paymentIntentId"
      }
    ],
    "concreteType": "UpdatePaymentIntentMutationPayload",
    "kind": "LinkedField",
    "name": "updatePaymentIntentAmount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentIntentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientSecret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feesPayer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildDonationScreenContentUpdateAmountMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GuildDonationScreenContentUpdateAmountMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "d93bbf1c1a7473bb11e620e4e166ea1b3c13685bef67a869a5c2868e8f2ae423",
    "metadata": {},
    "name": "GuildDonationScreenContentUpdateAmountMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7136ec06aa2087d878431b8418b9e0ce";

export default node;
